import Cards from './cards.svg';
import Creative from './creative.svg';
import InfoHand from './info-hand.svg';
import BookOpen from './book-open-solid.svg';
import BriefCase from './briefcase-regular.svg';
import Car from './car-regular.svg';
import Clock from './clock-regular.svg';
import Right from './circle-right.svg';
import Envelope from './envelope-solid.svg';
import Euro from './euro-sign-solid.svg';
import Exclamation from './exclamation-solid.svg';
import Fax from './fax-solid.svg';
import Globe from './globe-solid.svg';
import MapMarkedAlt from './map-marked-alt-light.svg';
import MapMarkerAlt from './map-marker-alt-regular.svg';
import PaperPlane from './paper-plane-light.svg';
import Parking from './parking-solid.svg';
import Phone from './phone-solid.svg';
import TShirt from './tshirt-solid.svg';
import Utensils from './utensils-regular.svg';
import Info from './info.svg';
import WineGlass from './wine-glass.svg';

const IconList = {
  Cards,
  Creative,
  InfoHand,
  Info,
  BookOpen,
  BriefCase,
  Car,
  Clock,
  Right,
  Envelope,
  Euro,
  Exclamation,
  Fax,
  Globe,
  MapMarkedAlt,
  MapMarkerAlt,
  PaperPlane,
  Parking,
  Phone,
  TShirt,
  Utensils,
  WineGlass,
};
export default IconList;
